/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import GradientScaleChartWithTooltip from '../../components/Gradient'
import Swal from 'sweetalert2'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

interface DashboardPageProps {
  showExamples: boolean
  reccomendedVariants: any[]
  themeMode: string
  gene: string
  setGene: (gene: string) => void
  setShowExamples: any
  onSearch: () => void
  fetchAutoCompleteGenes: (query: string) => void
  detectVariantType: (input: string) => string
  reccomenedGenes: any[]
}
const DashboardPage: FC<DashboardPageProps> = ({ reccomendedVariants, showExamples, setShowExamples, themeMode, gene, setGene, onSearch, fetchAutoCompleteGenes, detectVariantType, reccomenedGenes }) => (
  <>
    <div className="card h-100">
      <div className="card-body  dashboard-card d-flex flex-column align-items-center justify-content-center ">
        <div className='search-form-area col-md-12' style={{ margin: '0 auto', }}>
          <div className='vampp-logo m-auto d-flex flex-column align-items-center justify-content-center'>
            <img
              src={`/media/logos/vampp-logo-${themeMode === 'dark' ? 'white' : 'dark'}.png`}
              className='m-auto search-logo'
              alt='search'
            />
            <p className='mt-4 mb-0 fs-4'>
            <b>VA</b>riant <b>M</b>eta-<b>P</b>athogenicity <b>P</b>redictor-<b>score</b>
            </p>
            <p className='text-center col-md-6 mt-1 '>
              VAMPP-Score combines multiple computational tools from dbNSFP v4.9A (PMID: 21520341, PMID: 33261662) with statistical weighting to provide prediction accuracies. It emphasizes the evaluation of missense variants by incorporating gene-specific in silico pathogenicity predictor (ISPP) performance in distinguishing pathogenic from benign variants.
            </p>
          </div>
          <div className='search-inputs row mt-5  justify-content-center'>
            <div className='dropdown col-md-6 ' style={{ padding: 0, position: 'relative' }}>
              <input
                type="text"
                value={gene}
                onChange={(e) => {
                  const value = e.target.value;
                  setGene(value);

                  if (value.length > 2) {
                    const type = detectVariantType(value);
                    if (type === "gene") {
                      fetchAutoCompleteGenes(value);
                    }
                  }
                }}
                className="form-control form-control-solid rounded-0"
                placeholder="Search for genes, variants, positions…"
                onKeyUp={(e: any) => {
                  if (e.key === "Enter") {
                    onSearch();
                  }
                }}
              />


              {reccomenedGenes?.length > 0 && (
                <div
                  className="dropdown-menu w-100 show p-0"
                  style={{
                    position: 'absolute',
                    top: '100%',
                    zIndex: 10,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }}
                >
                  {reccomenedGenes.map((gene, index) => (
                    <a
                      key={index}
                      href={`search-gene/${gene}`}
                      className="dropdown-item"
                    >
                      <span className='fst-italic'>{gene}</span>
                    </a>
                  ))}
                </div>
              )}
              {reccomendedVariants?.length > 0 && (
                <div
                  className="dropdown-menu w-100 show p-0"
                  style={{
                    position: 'absolute',
                    top: '100%',
                    zIndex: 10,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }}
                >
                  {reccomendedVariants.map((variant, index) => (
                    <a
                      key={index}
                      href={`search-variant/${variant[0]}:${variant[1]}-${variant[2]}-${variant[3]}`}
                      className="dropdown-item"
                    >
                      {`${variant[0]}:${variant[1]}-${variant[2]}-${variant[3]} `}<span className='fst-italic'>{variant[4]}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
            <div className='dropdown col-md-1 search-button' style={{ padding: 0 }}>
              <button className='btn btn-primary rounded-0' onClick={() => onSearch()} >
                Search
              </button>
            </div>
            <div className="col-md-6 mt-3 text-center mt-3 position-relative">

              <button className='btn btn-light mb-4 rounded-0' onClick={() => setShowExamples(!showExamples)} >
                Example Inputs
              </button>
              <div className={`inputs-area ${showExamples ? 'd-block' : 'd-none'} `} style={{
                position: 'absolute',
                top: '100%',
              }}>
                <ul className='text-muted text-start  fs-7 d-flex flex-column gap-3'>
                  <li>
                    Enter gene information:{" "}
                    <span
                      className="clickable"
                      onClick={() => {
                        setGene("TP53")
                      }}
                    >
                      TP53
                    </span>{" "}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("HGNC:11998")}
                    >
                      HGNC:11998
                    </span>{" "}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("7157")}
                    >
                      7157
                    </span>{" "}
                    for NCBI gene ID
                  </li>
                  <li>
                    Enter variant information (hg38 genome assembly):{" "}
                    {/* <span
                      className="clickable"
                      onClick={() => setGene("NM_001368882.1(COL13A1):c.1786C>A")}
                    >
                      NM_001368882.1(COL13A1):c.1786C{`>`}A
                    </span>{" "}
                    or{" "} */}
                    {/* <span
                      className="clickable"
                      onClick={() => setGene("COL13A1:c.1786C>A")}
                    >
                      COL13A1:c.1786C{`>`}A
                    </span>{" "}
                    or{" "} */}
                    <span
                      className="clickable"
                      onClick={() => setGene("NM_001368882:c.1786C>A")}
                    >
                      NM_001368882:c.1786C{`>`}A
                    </span>{" "}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("chr10:69936771-C-A")}
                    >
                      chr10:69936771-C-A
                    </span>{" "}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("10:69936771-C-A")}
                    >
                      10:69936771-C-A
                    </span>
                  </li>
                  <li>
                    Enter genomic position information:{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("chr1:47416606")}
                    >
                      chr1:47416606
                    </span>{" "}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("1:47416606")}
                    >
                      1:47416606
                    </span>{" "}
                    {/* or{" "} */}
                    {/* <span
                      className="clickable"
                      onClick={() => setGene("FOXE3:c.291")}
                    >
                      FOXE3:c.291
                    </span>{" "} */}
                    or{" "}
                    <span
                      className="clickable"
                      onClick={() => setGene("rs762006562")}
                    >
                      rs762006562
                    </span>
                  </li>



                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const [themeMode, setThemeMode] = useState<string>('light')
  const [showExamples, setShowExamples] = useState<boolean>(false)
  const [reccomendedVariants, setReccomendedVariants] = useState<any[]>([])
  const serviceUrl = process.env.REACT_APP_VAMPPSCORE_BACKEND_BASE_URL
  const [reccomendedGenes, setReccomendedGenes] = useState<any[]>([]);



  function detectVariantType(input) {
    // Trim whitespace and validate input
    if (typeof input !== 'string' || input.trim() === '') {
      return 'invalid input'; // Handle empty or non-string inputs
    }


    // Normalize input
    const normalizedInput = input.trim();

    // Regex patterns
    const genePattern = /^[A-Za-z0-9]+$|^HGNC:\d+$|^\d+$|^NCBI:\d+$/i; // Gene names, HGNC IDs, NCBI IDs, or numeric Gene IDs
    const variantPattern = /^((NM_\d+\.\d+\(\w+\):c\.\d+[A-Z]>[A-Z])|(\w+:c\.\d+[A-Z]>[A-Z])|(chr\d+:\d+-[A-Z]-[A-Z])|(\d+:\d+-[A-Z]-[A-Z])|(NM_\d+\.\d+:c\.\d+[A-Z]>[A-Z]))$/i; // Variants
    const positionPattern = /^(chr\d+:\d+|\d+:\d+|\w+:[a-z]\.\d+|rs\d+)$/i; // Positions (includes FOXE3:c.291)


    // Determine type
    if (variantPattern.test(normalizedInput)) {
      return 'variant';
    } else if (positionPattern.test(normalizedInput)) {
      return 'position';
    } else if (genePattern.test(normalizedInput)) {
      return 'gene';
    }
    // If no match, return invalid input
    return 'error';
  }
  const [loading, setLoading] = useState<boolean>(false)
  const normalizeGene = (input: string) => {
    // Detect "chr" or "rs" prefixes and ensure they remain lowercase
    return input
      .replace(/(chr)(\d+)/i, (_, chr, rest) => `${chr.toLowerCase()}${rest}`) // Normalize "chr" to lowercase
      .replace(/(rs)(\d+)/i, (_, rs, rest) => `${rs.toLowerCase()}${rest}`); // Normalize "rs" to lowercase
  };
  const navigate = useNavigate();
  const onSearch = () => {
    const type = detectVariantType(gene)
    if (!gene) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a gene, variant or position',
      })
      return
    }
    if (type === 'error') {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Invalid input',
      })
      return
    }

    if (type === 'gene') {
      searchGene()
    }
    if (type === 'variant') {
      searchVariant()
    }
    if (type === 'position') {
      searchPosition()
    }
  }
  const searchGene = async () => {
    if (!gene) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a gene',
      })
      return
    }
    setLoading(true)
    try {
      Swal.fire({
        title: 'Loading',
        html: 'Please wait...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })
      const checkGene = await axios.get(`https://rest.ensembl.org/xrefs/symbol/homo_sapiens/${gene}?content-type=application/json;external_db=HGNC`)
      if (checkGene?.data?.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Gene does not exist',
        })
        return
      }
      Swal.close()
      navigate('/search-gene/' + gene.toLocaleUpperCase())
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.detail || 'An error occurred while fetching data',
      })
    } finally {
      setLoading(false)
    }
  }

  const searchPosition = async () => {
    if (!gene) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter ',
      })
      return
    }
    setLoading(true)
    const normalizedGene = normalizeGene(gene)
    try {
      Swal.fire({
        title: 'Loading',
        html: 'Please wait...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        },
      })
      const response = await axios.get(
        `${serviceUrl}/recommend_variant/${normalizedGene}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*',
          },
        }
      )
      const data = response.data
      if (data.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Gene not found',
        })
        return
      }
      Swal.close()
      console.log(data)
      setReccomendedVariants(data)
      // navigate('/search-gene/' + gene.toLocaleUpperCase())
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.detail || 'An error occurred while fetching data',
      })
    } finally {
      setLoading(false)
    }
  }
  const searchVariant = async () => {
    setLoading(true)
    if (!gene) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter a gene or variant',
      })
      return
    }
    const normalizedGene = normalizeGene(gene)
    Swal.fire({
      title: 'Loading',
      html: 'Please wait...',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
    })
    try {
      const response = await axios.get(`${serviceUrl}/vamppscore/variant/${normalizedGene}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*',
        },
      })
      const responsee = await axios.get(`${serviceUrl}/dbnsfp/variant/${normalizedGene}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*',
        },
      })
      const data = response.data
      if (data.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Variant not found',
        })
        return
      }
      Swal.close()
      navigate('/search-variant/' + normalizedGene)
    } catch (error: any) {

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error?.response?.data?.detail || 'An error occurred while fetching data',
      })

    } finally {
      setLoading(false)
    }
  }

  const fetchAutoCompleteGenes = async (query: string) => {
    try {
      const response = await axios.get(`${serviceUrl}/auto_complete/${query.toLocaleUpperCase()}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: '*',
        },
      });
      setReccomendedGenes(response.data);
    } catch (error) {
      console.error("Error fetching autocomplete genes:", error);
    }
  };
  //clear reccomended variants when gene changes

  useEffect(() => {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme')
    setThemeMode(currentTheme === 'light' ? 'light' : 'dark')

    const observer = new MutationObserver(() => {
      const updatedTheme = document.documentElement.getAttribute('data-bs-theme')
      setThemeMode(updatedTheme === 'light' ? 'light' : 'dark')
    })

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] })

    return () => observer.disconnect()
  }, [])

  const [gene, setGene] = useState<string>('')



  useEffect(() => {
    setReccomendedVariants([])
  }, [gene])


  return (
    <>
      <DashboardPage detectVariantType={detectVariantType} reccomenedGenes={reccomendedGenes} reccomendedVariants={reccomendedVariants} fetchAutoCompleteGenes={fetchAutoCompleteGenes} showExamples={showExamples} setShowExamples={setShowExamples} themeMode={themeMode} gene={gene} setGene={setGene} onSearch={onSearch} />
    </>
  )
}

export { DashboardWrapper }
